import gql from 'graphql-tag';

export default gql`
  mutation deleteTravelPlan($input: deleteTravelPlanInput!){
    deleteTravelPlan(input: $input){
      viewer {
        id
        repVisitsTravelPlan {
          id
        }
      }
    }
  }
`;
